<template>
  <div class="content">
    <el-card class="mb20 card1" :class="showNumber > 7 ? 'maxHeight' : 'minHeight'">
      <h4 class="title">实时数据</h4>
      <p class="deviceNumber">
        设备串号
        <span class="number">{{deviceData.deviceNumber}}</span>
        <span v-if="deviceData.deviceStatus === '1'" class="status blue">在线</span>
        <span v-if="deviceData.deviceStatus === '2'" class="status gray">离线</span>
      </p>
      <div class="paramList">
        <div v-for="(item, index) in paramList" class="paramItem" :class="{ gray: !item.value }" :key="index" v-show="deviceData[item.value]">
          <div class="icon">
            <i class="iconfont" :class="item.icon"></i>
          </div>
          <p class="ctt">
            <span class="name">{{item.name}}</span><br/>
            <span class="value">{{deviceData[item.value] || '--'}}</span>
          </p>
        </div>
      </div>
    </el-card>
    <el-card class="card2" :class="showNumber > 7 ? 'minHeight' : 'maxHeight'">
      <el-form ref="searchInfo" :model="searchInfo" class="global-form" :inline="true">
        <el-form-item prop="type">
          <el-select v-model="echartSelect" placeholder="请选择数据名称" @change="changeEchart">
            <div v-for="(item, index) in paramList" :key="index">
              <el-option :label="item.name" :value="item.value" v-if="getFind(item.value)"></el-option>
            </div>
          </el-select>
        </el-form-item>
        <el-form-item prop="dateRange">
          <el-date-picker
            :clearable = "false"
            v-model="searchInfo.dateRange"
            type="daterange"
            range-separator="-"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getData">查询</el-button>
        </el-form-item>
      </el-form>
      <div ref="echart" class="echart" :class="showNumber > 7 ? 'minHeight' : 'maxHeight'"></div>
    </el-card>
  </div>
</template>

<script>
import { directionTransition } from '@/utils/formatData'
// import * as echarts from 'echarts'
import { px2vw } from '@/utils/util'
export default {
  name: 'WaterHistory',
  data () {
    return {
      paramList: [
        {
          icon: 'icon-wendu',
          name: '温度(°C)',
          value: 'temperature',
          data: []
        }, {
          icon: 'icon-shidu',
          name: '湿度(%)',
          value: 'humidity',
          data: []
        }, {
          icon: 'icon-jiangyuliang',
          name: '降雨量(mm)',
          value: 'precipitation',
          data: []
        }, {
          icon: 'icon-qiya',
          name: '气压(pa)',
          value: 'pressure',
          data: []
        }, {
          icon: 'icon-fengxiang',
          name: '风向',
          value: 'direction',
          data: []
        }, {
          icon: 'icon-a-PM25',
          name: 'PM2.5(μg/m³)',
          value: 'pm25',
          data: []
        }, {
          icon: 'icon-zaoyin',
          name: '噪音(db)',
          value: 'noise',
          data: []
        }, {
          icon: 'icon-fengsu',
          name: '风速(m/s)',
          value: 'speed',
          data: []
        }, {
          icon: 'icon-fuyanglizi',
          name: '负氧离子(个/cm³)',
          value: 'negativeOxyge',
          data: []
        }, {
          icon: 'icon-guangzhao',
          name: '光照(Lux)',
          value: 'lux',
          data: []
        }, {
          icon: 'icon-pm10',
          name: 'PM10(μg/m³)',
          value: 'pm10',
          data: []
        }, {
          icon: 'icon-co2',
          name: '二氧化碳(ppm)',
          value: 'co2',
          data: []
        }, {
          icon: 'icon-taiyangfushe',
          name: '太阳总辐射(mwh/cm²)',
          value: 'zfs',
          data: []
        }
      ],
      collectTime: [],
      deviceData: {},
      showNumber: 0,
      finds: [],
      dataList: [],
      echartSelect: '',
      searchInfo: {
        dateRange: []
      },
      typeColor: [
        'rgba(255, 158, 88, 1)',
        'rgba(19, 177, 244, 1)',
        'rgba(19, 177, 244, 1)',
        'rgba(90, 112, 220, 1)',
        'rgba(54, 203, 203, 1)',
        'rgba(109, 212, 0, 1)',
        'rgba(255, 113, 120, 1)',
        'rgba(54, 203, 203, 1)',
        'rgba(24, 144, 255, 1)',
        'rgba(255, 158, 88, 1)',
        'rgba(109, 212, 0, 1)',
        'rgba(24, 144, 255, 1)',
        'rgba(255, 158, 88, 1)'
      ],
      selectTime: 0,
      pickerOptions: {
        // 选中日期后会执行的回调
        onPick: (date) => {
          this.selectTime = date.minDate.getTime()
          if (date.maxDate) {
            this.selectTime = 0
          }
        },
        disabledDate: (time) => {
          if (this.selectTime !== 0) {
            const dayTime = 29 * 24 * 3600 * 1000
            const minTime = this.selectTime - dayTime
            const maxTime = this.selectTime + dayTime
            return (time.getTime() < minTime || time.getTime() > maxTime)
          }
        }
      },
      echart: null
    }
  },
  computed: {
    deviceNumber () {
      return this.$route.params.deviceNumber
    }
  },
  created () {
    this.initTime()
    this.getData()
    this.getDetail()
  },
  mounted () {
    window.addEventListener('resize', this.resize)
  },
  destroyed () {
    window.removeEventListener('resize', this.resize)
  },
  methods: {
    initTime () {
      const val = this.$dayjs().format('YYYY-MM-DD')
      const vals = this.$dayjs().subtract(7, 'day').format('YYYY-MM-DD')
      this.searchInfo.dateRange = [vals, val]
    },
    getDetail () {
      this.$axios.get(this.$apis.iot.selectWeatherInfoByDeviceNumber, {
        deviceNumber: this.deviceNumber
      }).then((res) => {
        this.deviceData = res
        if (this.deviceData.direction) {
          this.deviceData.direction = directionTransition(this.deviceData.direction)
        }
        for (const key in this.deviceData) {
          this.paramList.forEach(item => {
            if (item.value === key && this.deviceData[key]) {
              this.showNumber++
            }
          })
        }
      })
    },
    getData () {
      if (this.searchInfo.dateRange && this.searchInfo.dateRange[0]) {
        this.$axios.get(this.$apis.iot.selectWeatherDataByPage, {
          deviceNumber: this.deviceNumber,
          startTime: this.searchInfo.dateRange[0],
          endTime: this.searchInfo.dateRange[1]
        }).then((res) => {
          this.finds = res.finds
          this.echartSelect = this.echartSelect || res.finds[0]
          this.dataList = res.jgWeatherInfo.list
          this.getChartData()
        })
      } else {
        this.$message.error('请选择查询日期范围')
      }
    },
    getChartData () {
      this.paramList.forEach(item => {
        item.data = []
      })
      this.collectTime = []
      const index = this.paramList.findIndex((item) => item.value === this.echartSelect)
      const title = this.paramList[index].name
      const color = this.typeColor[index]
      if (this.dataList.length > 0) {
        this.dataList.forEach(item => {
          this.paramList[0].data.push(item.temperature)
          this.paramList[1].data.push(item.humidity)
          this.paramList[2].data.push(item.precipitation)
          this.paramList[3].data.push(item.pressure)
          this.paramList[4].data.push(item.direction)
          this.paramList[5].data.push(item.pm25)
          this.paramList[6].data.push(item.noise)
          this.paramList[7].data.push(item.speed)
          this.paramList[8].data.push(item.negativeOxyge)
          this.paramList[9].data.push(item.pm10)
          this.paramList[10].data.push(item.co2)
          this.paramList[11].data.push(item.lux)
          this.paramList[12].data.push(item.zfs)
          this.collectTime.push(item.collectTime)
        })
      }
      this.draw(title, [color], this.collectTime || [], this.paramList[index].data || [])
    },
    changeEchart () {
      this.getChartData()
    },
    draw (title, color, xData, yData) {
      this.$nextTick(() => {
        this.echart = echarts.init(this.$refs.echart)
        const name = title.indexOf('(') > 0 ? title.substring(0, title.indexOf('(')) : title
        const option = {
          tooltip: {
            trigger: 'axis'
          },
          grid: {
            top: px2vw(80),
            left: px2vw(40),
            right: px2vw(30),
            bottom: 0,
            containLabel: true
          },
          title: {
            text: title,
            textStyle: {
              fontSize: px2vw(18),
              fontWeight: px2vw(400),
              color: '#000000'
            }
          },
          legend: {
            icon: 'rect',
            top: px2vw(40),
            left: 0,
            itemWidth: px2vw(20),
            itemHeight: px2vw(1),
            itemGap: px2vw(5),
            textStyle: {
              color: '#8C8C8C'
            }
          },
          backgroundColor: 'transparent',
          color: color,
          xAxis: {
            type: 'category',
            axisTick: {
              alignWithLabel: {
                boundaryGap: true
              }
            },
            axisLine: {
              lineStyle: {
                color: '#DDDDDD'
              }
            },
            axisLabel: {
              show: true,
              margin: 15,
              textStyle: {
                color: '#999999'
              }
            },
            data: xData
          },
          yAxis: {
            type: 'value',
            axisLine: {
              show: false,
              lineStyle: {
                color: 'rgba(0, 0, 0, 0.45)'
              }
            },
            axisTick: {
              show: false
            },
            splitLine: {
              lineStyle: {
                color: 'rgba(0, 0, 0, 0.15)'
              }
            }
          },
          series: [{
            name: name,
            type: 'line',
            symbolSize: 0,
            itemStyle: {
              normal: {
                borderWidth: px2vw(2)
              }
            },
            data: yData
          }]
        }

        this.echart.setOption(option)
      })
    },
    resize () {
      if (this.echart) {
        this.echart.resize()
      }
    },
    // 判断展示字段
    getFind (str) {
      return this.finds.find((item) => item === str)
    }
  }
}
</script>

<style scoped lang='scss'>
@import '@/assets/scss/variables.scss';
.content {
  height: calc(100% - 45px);
  overflow-y: auto;
  .card1 {
    ::v-deep .el-card__body {
      padding: 20px 12px 0px 12px;
    }
    &.maxHeight {
      height: 340px;
    }
    &.minHeight {
      height: 220px;
    }
  }
  .card2 {
    &.maxHeight {
      height: 685px;
    }
    &.minHeight {
      height: 565px;
    }
  }
}

.title {
  font-size: 18px;
  color: $color-font-dark;
  line-height: 22px;
  margin-bottom: 10px;
}

.deviceNumber {
  font-size: 14px;
  color: $color-font-dark;
  margin-bottom: 20px;

  .number {
    color: $color-font-default;
    margin-left: 10px;
  }

  .status {
    display: inline-block;
    width: 44px;
    height: 20px;
    font-size: 12px;
    color: #fff;
    text-align: center;
    line-height: 20px;
    border-radius: 2px;
    margin-left: 10px;

    &.blue {
      background: $--color-primary;
    }

    &.gray {
      background: #B7B7B7;
    }
  }
}

@media screen and (max-width: 1465px) {
  .paramList .paramItem .ctt {
    text-align: center;
  }
}

.paramList {
  display: flex;
  flex-wrap: wrap;
  .paramItem {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
    background: rgba(252, 252, 252, 1);
    padding: 15px 15px 15px 30px;
    margin: 0px 8px 20px 8px;
    width: 212px;

    .icon {
      position: relative;
      width: 54px;
      height: 54px;
      color: #fff;
      text-align: center;
      border-radius: 50%;
      margin: 8px;
      background: rgba(19, 177, 244, 1);

      &:before {
        content: '';
        position: absolute;
        top: -8px;
        left: -8px;
        width: 70px;
        height: 70px;
        border: 8px solid rgba(19, 177, 244, 0.2);
        border-radius: 50%;
        background: transparent;
      }

      .iconfont {
        font-size: 28px;
        line-height: 54px;
      }
    }

    .ctt {
      padding: 0 10px;
      max-width: 95px;
    }

    .name {
      font-size: 12px;
      color: #666666;
      line-height: 18px;
      margin: 15px 0 8px;
    }

    .value {
      font-family: 'DINAlternateBold';
      font-size: 32px;
      line-height: 34px;
      color: #13B1F4;
    }
    &:nth-child(1) {
      .icon {
        background-color: rgba(255, 158, 88, 1);

        &:before {
          border-color: rgba(255, 158, 88, 0.2);
        }
      }

      .value {
        color: rgba(255, 158, 88, 1);
      }
    }

    &:nth-child(4) {
      .icon {
        &:before {
          border-color:rgba(90, 112, 220, 0.2);
        }

        background-color:rgba(90, 112, 220, 1);
      }

      .value {
        color: rgba(90, 112, 220, 1);
      }
    }

    &:nth-child(5) {
      .icon {
        &:before {
          border-color:rgba(54, 203, 203, 0.2);
        }

        background-color: rgba(54, 203, 203, 1);
      }

      .value {
        font-size: 25px;
        color:  rgba(54, 203, 203, 1);
      }
    }

    &:nth-child(6) {
      .icon {
        &:before {
          border-color:rgba(109, 212, 0, 0.2);
        }

        background-color:rgba(109, 212, 0, 1);
      }

      .value {
        color: rgba(109, 212, 0, 1);
      }
    }

    &:nth-child(7) {
      .icon {
        &:before {
          border-color: rgba(255, 113, 120, 0.2);
        }

        background-color:rgba(255, 113, 120, 1);
      }

      .value {
        color: rgba(255, 113, 120, 1);
      }
    }

    &:nth-child(8) {
      .icon {
        &:before {
          border-color:rgba(54, 203, 203, 0.2);
        }

        background-color: rgba(54, 203, 203, 1);
      }

      .value {
        color:  rgba(54, 203, 203, 1);
      }
    }

    &:nth-child(9) {
      .icon {
        &:before {
          border-color:rgba(24, 144, 255, 0.2);
        }

        background-color: rgba(24, 144, 255, 1);
      }

      .value {
        color:  rgba(24, 144, 255, 1);
      }
   /*   width: 12%;*/
    }
    &:nth-child(10) {
      .icon {
        &:before {
          border-color:rgba(255, 158, 88, 0.2);
        }

        background-color: rgba(255, 158, 88, 1);
      }

      .value {
        color:  rgba(255, 158, 88, 1);
      }
    }
    &:nth-child(11) {
      .icon {
        &:before {
          border-color:rgba(109, 212, 0, 0.2);
        }

        background-color: rgba(109, 212, 0, 1);
      }

      .value {
        color:  rgba(109, 212, 0, 1);
      }
    }
    &:nth-child(12) {
      .icon {
        &:before {
          border-color:rgba(24, 144, 255, 0.2);
        }

        background-color: rgba(24, 144, 255, 1);
      }

      .value {
        color:  rgba(24, 144, 255, 1);
      }
    }
    &:nth-child(13) {
      .icon {
        &:before {
          border-color:rgba(255, 158, 88, 0.2);
        }

        background-color: rgba(255, 158, 88, 1);
      }

      .value {
        color:  rgba(255, 158, 88, 1);
      }
    }
  }

}

.echart {
  width: 100%;
  &.minHeight {
    height: 470px;;
  }
  &.maxHeight {
    height: 590px;
  }
}
</style>
